import { Currency, CurrencyUtil } from "@mcleod/core";
import { AutogenLayoutARInquiry } from "./autogen/AutogenLayoutARInquiry";
import { ClickEvent, Label, Textbox } from "@mcleod/components";
import { Orders } from "@mcleod/dispatch/src/Orders";

export class ARInquiry extends AutogenLayoutARInquiry {

    sourceArinquiryOnDisplayAfterExecution(event) {
        this.mainDataSource.activeRow?.set("unposted", this.mainDataSource.summaryData.get("unposted"));
        this.mainDataSource.activeRow?.set("misc_bills", this.mainDataSource.summaryData.get("misc_bills"));
        this.mainDataSource.activeRow?.set("credit_memos", this.mainDataSource.summaryData.get("credit_memos"));
        this.mainDataSource.activeRow?.set("cash_receipts", this.mainDataSource.summaryData.get("cash_receipts"));
        this.mainDataSource.activeRow?.set("net_total", this.mainDataSource.summaryData.get("net_total"));
    }

    orderIdOnClick(event: ClickEvent) {
        const orderId = event.target as Label;
        if (orderId.text && orderId.text !== "") {
            Orders.navigateTo(orderId.text);
        }
    }

}
